/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { GetPractitionerAtLocationData } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Locations<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags locations-controller
   * @name GetPractitionerAtLocation
   * @request GET:/locations/{clinicLocationGuid}/practitioners
   */
  getPractitionerAtLocation = (
    clinicLocationGuid: string,
    query?: {
      /**
       * @format int32
       * @min 1
       * @max 100
       */
      maxResults?: number;
      nextToken?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<GetPractitionerAtLocationData, any>({
      path: `/locations/${clinicLocationGuid}/practitioners`,
      method: 'GET',
      query: query,
      ...params,
    });
}
